import * as actionTypes from "../actions/actionTypes";

import {
	getCompanyData,
	updateCompanyPost,
	setCompanyLoader,
	companyPageIncreament,
	clearCompanyData,
	setTotal
} from "../utility/companyFunctions";

const initialState = {
	companyData: [],
	total: "",
	isLoading: true,
	page: 1,
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_COMPANY_DATA:
			return getCompanyData(state, action.companyData, action.total);

		case actionTypes.SET_COMPANY_LOADER:
			return setCompanyLoader(state, action.loaderValue);

		case actionTypes.COMPANY_PAGE_INCREAMENT:
			return companyPageIncreament(state);

		case actionTypes.UPDATE_COMPANY_POST:
			return updateCompanyPost(state, action.post)

		case actionTypes.CLEAR_COMPANY_DATA:
			return clearCompanyData(state);

		case actionTypes.SET_TOTAL_COMPANY:
			return setTotal(state, action.total);

		default:
			return state;
	}
};

export default reducer;